<template>
    <div class="container mt-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h3 class="mb-0">Group Plans   <small class="text-muted" style=" font-size: 14px;">[{{ groupname }} (#{{ groupId }})]</small></h3>
        <div class="d-flex align-items-center gap-2 flex-nowrap" style="overflow:auto; white-space: nowrap;">
          <input
            v-model.trim="q"
            @keyup.enter="reload()"
            type="search"
            class="form-control"
            placeholder="ค้นหาแผน (กด Enter)"
            style="max-width: 260px;"
          />
          <select v-model.number="size" class="form-select" style="width: 120px;">
            <option :value="10">10 / หน้า</option>
            <option :value="20">20 / หน้า</option>
            <option :value="50">50 / หน้า</option>
          </select>
          <button class="btn btn-outline-primary" :disabled="loading" @click="reload()">
            {{ loading ? 'กำลังโหลด...' : 'รีเฟรช' }}
          </button>
          <!-- Add -->
          <div style="max-width: 200px; min-width: 110px;">
                <button class="btn btn-success"  :disabled="loading" @click="openAddPlanModal">
                   <!-- //addUser -->
            + Add Plan 
            </button>
            </div>
        </div>
      </div>
  
      <div v-if="error" class="alert alert-danger py-2">
        {{ error }}
      </div>
  
      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th style="width: 64px;">#</th>
              <th>Plan Name</th>
              <th>Description</th>
              <th style="width: 180px;">Created At</th>
              <th style="width:120px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="4" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
            </tr>
  
            <tr v-else-if="plans.length === 0">
              <td colspan="4" class="text-center text-muted py-4">ไม่พบข้อมูล</td>
            </tr>
  
            <tr v-else v-for="(plan, idx) in plans" :key="plan.id ?? idx">
              <td>{{ (page - 1) * size + idx + 1 }}</td>
              <td>{{ plan.name ?? '-' }}</td>
              <td>{{ plan.description ?? '-' }}</td>
              <td>{{ formatDate(plan.createdAt) }}</td>
              <td>
                <button class="btn btn-sm btn-outline-danger" :disabled="loading"
                        @click="removePlan(plan.id)">
                    Remove
                </button>
               </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center mt-2">
        <div class="text-muted">
          ทั้งหมด: {{ meta.total ?? 0 }} รายการ
        </div>
        <div class="btn-group">
          <button class="btn btn-outline-secondary" :disabled="page <= 1 || loading" @click="prevPage">ก่อนหน้า</button>
          <span class="btn btn-outline-secondary disabled">หน้า {{ page }}</span>
          <button class="btn btn-outline-secondary" :disabled="disableNext || loading" @click="nextPage">ถัดไป</button>
        </div>
      </div>
    </div>

    <!-- Add Plan Modal -->
    <Transition name="modal-fade-zoom">
      <div v-if="showAddPlanModal" class="mc-backdrop" @click.self="closeAddPlanModal">
        <div class="mc-card" role="dialog" aria-modal="true" aria-labelledby="addPlanTitle">
          <div class="mc-header">
            <h5 id="addPlanTitle" class="mb-0">เพิ่มแผนเข้ากลุ่ม</h5>
            <button class="mc-close" @click="closeAddPlanModal" aria-label="Close"></button>
          </div>

          <div class="mc-toolbar">
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-search"></i>
              </span>
              <input
                v-model.trim="qAllPlans"
                @keyup.enter="reloadAllPlans"
                type="search"
                class="form-control"
                placeholder="ค้นหาแผนทั้งหมด (กด Enter)"
              />
            </div>

            <div class="d-flex align-items-center gap-2">
              <select v-model.number="sizeAllPlans" class="form-select form-select-sm" style="width: 120px;">
                <option :value="10">10 / หน้า</option>
                <option :value="20">20 / หน้า</option>
                <option :value="50">50 / หน้า</option>
              </select>

              <button class="btn btn-primary btn-sm" :disabled="loadingAllPlans" @click="reloadAllPlans">
                <span v-if="loadingAllPlans" class="spinner-border spinner-border-sm me-1"></span>
                ค้นหา
              </button>
            </div>
          </div>

          <div class="mc-body">
            <div v-if="errorAllPlans" class="alert alert-danger py-2 mb-2">{{ errorAllPlans }}</div>

            <div class="table-responsive mc-table-wrap">
              <table class="table table-hover align-middle">
                <thead class="table-light mc-thead-sticky">
                  <tr>
                    <th style="width:64px;">#</th>
                    <th>Plan Name</th>
                    <th>Description</th>
                    <th style="width:120px;">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loadingAllPlans">
                    <td colspan="4" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
                  </tr>
                  <tr v-else-if="allPlans.length === 0">
                    <td colspan="4" class="text-center text-muted py-4">ไม่พบแผน</td>
                  </tr>
                  <tr v-else v-for="(p, idx) in allPlans" :key="p.id ?? idx">
                    <td>{{ (pageAllPlans - 1) * sizeAllPlans + idx + 1 }}</td>
                    <td class="fw-600">{{ p.name ?? '-' }}</td>
                    <td class="text-muted">{{ p.description ?? '-' }}</td>
                    <td>
                      <button
                        class="btn btn-sm"
                        :class="isPlanAlreadyInGroup(p.id) ? 'btn-outline-secondary' : 'btn-success'"
                        :disabled="loadingAllPlans || isPlanAlreadyInGroup(p.id)"
                        @click="addPlanById(p.id)"
                      >
                        {{ isPlanAlreadyInGroup(p.id) ? 'Added' : 'Add' }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mc-footer">
            <div class="text-muted">ทั้งหมด: {{ metaAllPlans.total ?? 0 }} รายการ</div>
            <div class="btn-group">
              <button class="btn btn-outline-secondary btn-sm" :disabled="pageAllPlans <= 1 || loadingAllPlans" @click="prevPageAllPlans">ก่อนหน้า</button>
              <span class="btn btn-outline-secondary btn-sm disabled">หน้า {{ pageAllPlans }}</span>
              <button class="btn btn-outline-secondary btn-sm" :disabled="disableNextAllPlans || loadingAllPlans" @click="nextPageAllPlans">ถัดไป</button>
            </div>
            <button class="btn btn-secondary btn-sm ms-auto" @click="closeAddPlanModal">ปิด</button>
          </div>
        </div>
      </div>
    </Transition>
  </template>
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount, watch, computed } from "vue";
  import { useRoute, useRouter } from "vue-router";
  
  const route = useRoute();
  const router = useRouter();
  const rawname = route.params.name || "";
  const groupId = route.params.id;
  const groupname = ref(decodeURIComponent(rawname));
  const API_URL = process.env.VUE_APP_API_URL
  const loading = ref(false);
  const error = ref("");
  const plans = ref([]);
  const meta = ref({ total: 0 });
  
  // ควบคุมการค้นหาและเพจจิ้ง
  const q = ref("");
  const page = ref(1);
  const size = ref(10);
  
  const disableNext = computed(() => {
    const total = meta.value?.total ?? 0;
    return page.value * size.value >= total;
  });
  
  function getToken() {
    return localStorage.getItem("accessToken"); // ให้สอดคล้องกับ router guard ของคุณ
  }
  
  function authHeaders() {
    const token = getToken();
    return token
      ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
      : { "Content-Type": "application/json" };
  }

  function handle401() {
  localStorage.removeItem("accessToken");
  router.push("/login");
}
  
  function formatDate(dt) {
    if (!dt) return "-";
    try {
      const d = new Date(dt);
      if (isNaN(d)) return String(dt);
      return d.toLocaleString();
    } catch {
      return String(dt);
    }
  }
  
  async function apiFetch(url) {
    const res = await fetch(url, { headers: authHeaders() });
    if (res.status === 401) {
      // token ไม่ถูกต้อง / หมดอายุ
      localStorage.removeItem("accessToken");
      router.push("/login");
      throw new Error("Unauthorized");
    }
    if (!res.ok) {
      const t = await res.text().catch(() => "");
      throw new Error(t || `HTTP ${res.status}`);
    }
    return res.json();
  }

  async function apiPost(url, body) {
    const res = await fetch(url, { method: "POST", headers: authHeaders(true), body: JSON.stringify(body) });
    if (res.status === 401) { handle401(); throw new Error("Unauthorized"); }
    if (!res.ok) throw new Error(await res.text().catch(() => `HTTP ${res.status}`));
    return res.json();
    }
    async function apiDelete(url) {
    const res = await fetch(url, { method: "DELETE", headers: authHeaders(false) });
    if (res.status === 401) { handle401(); throw new Error("Unauthorized"); }
    if (!res.ok) throw new Error(await res.text().catch(() => `HTTP ${res.status}`));
    return res.json().catch(() => ({}));
    }
  
  async function load() {
    if (!API_URL) {
      error.value = "ไม่พบค่า VUE_APP_API_URL / VITE_API_URL";
      return;
    }
    loading.value = true;
    error.value = "";
    try {
      const query = new URLSearchParams({
        ...(q.value ? { q: q.value } : {}),
        page: String(page.value),
        size: String(size.value),
      });
      const url = `${API_URL}/api/group/${groupId}/plans?` + query.toString();
      const json = await apiFetch(url);
  
      plans.value = Array.isArray(json?.data) ? json.data : [];
      meta.value = json?.meta ?? { total: plans.value.length };
     
    } catch (e) {
      error.value = e?.message ?? "โหลดข้อมูลล้มเหลว";
    } finally {
      loading.value = false;
    }
  }
  
  function reload() {
    page.value = 1; // รีเซ็ตหน้าเมื่อค้นหา/เปลี่ยน size
    load();
  }
  function nextPage() {
    if (!disableNext.value) {
      page.value += 1;
      load();
    }
  }
  function prevPage() {
    if (page.value > 1) {
      page.value -= 1;
      load();
    }
  }
  
  onMounted(load);
  watch([() => route.params.id], load);
  watch(size, reload);


  // ====== Modal Add Plan states ======
    const showAddPlanModal = ref(false);
    const allPlans = ref([]);
    const metaAllPlans = ref({ total: 0 });
    const loadingAllPlans = ref(false);
    const errorAllPlans = ref("");

    const qAllPlans = ref("");
    const pageAllPlans = ref(1);
    const sizeAllPlans = ref(10);

    

    const disableNextAllPlans = computed(() => {
      const total = metaAllPlans.value?.total ?? 0;
      return pageAllPlans.value * sizeAllPlans.value >= total;
    });

    // แผนที่มีอยู่ในกลุ่มแล้ว (กันกด Add ซ้ำ)
    const existingPlanIds = computed(() => new Set(plans.value.map(p => p.id)));
    function isPlanAlreadyInGroup(planId){
      return existingPlanIds.value.has(planId);
    }

    function openAddPlanModal(){
      showAddPlanModal.value = true;
      pageAllPlans.value = 1;
      loadAllPlans();
    }
    function closeAddPlanModal(){
      showAddPlanModal.value = false;
    }

    // ปิดด้วย ESC
    function onEscPlan(e){
      if (e.key === "Escape" && showAddPlanModal.value) closeAddPlanModal();
    }
    onMounted(() => window.addEventListener("keydown", onEscPlan));
    onBeforeUnmount(() => window.removeEventListener("keydown", onEscPlan));

    // โหลดรายการแผนทั้งหมด (ทั้งระบบ)
    async function loadAllPlans(){
      if (!API_URL) { errorAllPlans.value = "ไม่พบค่า VUE_APP_API_URL / VITE_API_URL"; return; }
      loadingAllPlans.value = true; errorAllPlans.value = "";
      try{
      
        const query = new URLSearchParams({
          ...(qAllPlans.value ? { q: qAllPlans.value } : {}),
          page: String(pageAllPlans.value),
          size: String(sizeAllPlans.value),
        });
        const res = await fetch(`${API_URL}/api/plan?`+ query.toString(), { headers: authHeaders(false) });
        if (res.status === 401) { handle401(); throw new Error("Unauthorized"); }
        if (!res.ok) throw new Error(await res.text().catch(()=>`HTTP ${res.status}`));
        const json = await res.json();
        allPlans.value = Array.isArray(json?.data) ? json.data : [];
        metaAllPlans.value = json?.meta ?? { total: allPlans.value.length };
      }catch(e){
        errorAllPlans.value = e?.message ?? "โหลดแผนทั้งหมดล้มเหลว";
      }finally{
        loadingAllPlans.value = false;
      }
    }

    function reloadAllPlans(){ pageAllPlans.value = 1; loadAllPlans(); }
    function nextPageAllPlans(){ if(!disableNextAllPlans.value){ pageAllPlans.value += 1; loadAllPlans(); } }
    function prevPageAllPlans(){ if(pageAllPlans.value > 1){ pageAllPlans.value -= 1; loadAllPlans(); } }

    // กด Add ที่แต่ละแถว
    async function addPlanById(planId){
      if (!planId) return;
      try{
        loadingAllPlans.value = true;
        // endpoint เพิ่มแผนเข้ากลุ่ม
        await apiPost(`${API_URL}/api/group/${groupId}/plan`, { planId });
        await Promise.all([loadAllPlans(), load()]); // รีโหลด modal + ตารางหลัก
        alert("เพิ่มแผนเข้ากลุ่มสำเร็จ");
      }catch(e){
        alert("เพิ่มแผนไม่สำเร็จ: " + (e?.message || ""));
      }finally{
        loadingAllPlans.value = false;
      }
    }
    async function removePlan(planId) {
      if (!window.confirm("ยืนยันลบผู้ใช้ออกจากกลุ่ม?")) return;
      try {
        loading.value = true;
        await apiDelete(`${API_URL}/api/group/${groupId}/plan/${planId}`);
        await load();
        alert("นำผู้ใช้ออกจากกลุ่มสำเร็จ");
      } catch (e) {
        alert("ลบไม่สำเร็จ: " + (e?.message || ""));
      } finally {
        loading.value = false;
      }
    }

  </script>
  


  <style scoped>
  .table td,.table th{ vertical-align: middle; }

  /* ===== Modern Clean Modal ===== */
  .mc-backdrop{
    position: fixed; inset: 0; z-index: 1060;
    display:flex; align-items:center; justify-content:center;
    background: rgba(15, 23, 42, 0.45);
    backdrop-filter: blur(4px);
  }

  .mc-card{
    width: min(920px, 95vw);
    max-height: min(80vh, 880px);
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 10px 20px rgba(0,0,0,.08), 0 30px 60px rgba(0,0,0,.12);
    overflow: hidden;
    display:flex; flex-direction:column;
  }

  .mc-header{
    position: sticky; top: 0;
    display:flex; align-items:center; justify-content:space-between;
    gap: 12px; padding: 14px 16px;
    border-bottom: 1px solid #eef2f7;
    background: linear-gradient(#ffffff, #fafbfc);
  }
  .mc-toolbar{
    display:flex; align-items:center; justify-content:space-between;
    gap: 12px; padding: 12px 16px;
    border-bottom: 1px solid #f0f3f8; background: #fff;
  }
  .mc-body{ padding: 0 16px 12px 16px; overflow: hidden; }
  .mc-footer{
    position: sticky; bottom: 0;
    display:flex; align-items:center; gap: 12px;
    padding: 10px 16px; border-top: 1px solid #eef2f7;
    background: linear-gradient(#fafbfc, #ffffff);
  }

  /* Close button */
  .mc-close{
    width: 32px; height: 32px; border: 0; border-radius: 8px;
    background: transparent; position: relative; opacity: .7;
  }
  .mc-close:hover{ opacity: 1; background: #f5f6f8; }
  .mc-close::before, .mc-close::after{
    content:""; position:absolute; left:9px; right:9px; top:15px;
    height:2px; background:#64748b;
  }
  .mc-close::before{ transform: rotate(45deg); }
  .mc-close::after{ transform: rotate(-45deg); }  /* ← แก้ . ขาด */

  .mc-table-wrap{
    max-height: 52vh;
    overflow:auto; border: 1px solid #eef2f7; border-radius: 12px;
  }
  .mc-thead-sticky th{
    position: sticky; top: 0; z-index: 1;
    background: #f8fafc !important;
    border-bottom: 1px solid #e9eef5 !important;
  }
  .fw-600{ font-weight: 600; }

  /* Transition */
  .modal-fade-zoom-enter-active,
  .modal-fade-zoom-leave-active{ transition: all .18s ease; }
  .modal-fade-zoom-enter-from,
  .modal-fade-zoom-leave-to{ opacity:0; transform: translateY(6px) scale(.98); }
  </style>